import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  header: {
    flex: 1,
    paddingHorizontal: 30,
    marginTop: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    alignSelf: "flex-start",
  },
  header_action_container: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  header_text: {
    marginRight: 10,
    color: "#2C2C2E",
  },
  assets_list: {
    flex: 1,
    padding: 10,
    marginTop: 5,
    position: "absolute",
    top: "20%",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  asset: {
    alignSelf: 'center',
    margin: 5,
    paddingHorizontal: 10,
    height: 100,
    width: 100,
    alignItems: "center",
    backgroundColor: "#FFF",
    borderTopLeftRadius: 10,
    justifyContent: "center",
    borderBottomRightRadius: 10,
  },
  asset_name: {
    textTransform: "uppercase",
    marginTop: 5,
    fontSize: 12,
    color: "#2C2C2E",
    opacity: 0.8,
    fontWeight: "bold",
  },
  asset_icon: {
    width: 50,
    height: 50,
  },
  tokens_list: {
    position: "absolute",
    bottom: 0,
    width: "90%",
    height: "42%",
    alignItems: "center",
    backgroundColor: "#fff",
    borderTopLeftRadius: 35,
    borderTopRightRadius: 35,
  },
  tokens_display_action: {
    alignItems: "center",
    paddingVertical: 10,
  },
  token: {
    flex: 1,
    padding: 10,
    borderWidth: 1,
    borderRadius: 5,
    marginBottom: 20,
    alignItems: "center",
    flexDirection: "row",
    borderColor: "#F4F4F4",
    justifyContent: "space-between",
  },
  scroll_view: {
    flex: 1,
    width: "100%",
    height: "30%",
    padding: 20,
    position: "absolute",
    top: "25%",
    height: "50%",
  },
});

export default styles;
